<template>
  <ml-form
    labelWidth="100px"
    style="width: 100%; padding: 0 24px; box-sizing: border-box"
    :model="submitReportForm"
    :rules="submitReportFormRule"
    ref="submitReportFormRef"
    :disabled="formDisable"
    :label-width="'150px'"
  >
    <!-- 办结描述 -->
    <ml-date-picker
      prop="startTime"
      placeholder="请选择开始时间"
      label="开始时间:"
      type="datetime"
      valueFormat="YYYY-MM-DD HH:mm:ss"
      v-model="submitReportForm.startTime"
    />
    <ml-date-picker
      prop="endTime"
      placeholder="请选择结束时间"
      label="结束时间:"
      type="datetime"
      valueFormat="YYYY-MM-DD HH:mm:ss"
      v-model="submitReportForm.endTime"
    />
    <ml-input
      prop="content"
      placeholder="请输入内容描述"
      label="内容描述"
      type="textarea"
      :rows="5"
      v-model="submitReportForm.content"
    />
    <el-form-item>
      <template #label>
        <span>安全作业附件</span>
        <el-tooltip content="上传的图片必须符合涉水、涉电、高空、道路作业中的一项要求" placement="top">
          <i class="el-icon-question" style="cursor: pointer; margin-left: 4px"></i>
        </el-tooltip>
      </template>
      <ml-upload
        multiple
        autoUpload
        :showFileList="false"
        :action="action"
        :data="{ linkType: 'error', type: 1 }"
        :headers="{ Authorization: toKen }"
        name="files"
        @on-success="onSafetyUploadSuccess"
      >
        <el-button size="medium" icon="el-icon-circle-plus-outline" type="primary">
          上传附件
        </el-button>
      </ml-upload>
      <ml-list fileName="fileName" :list="submitReportForm.safetyAttachVos" :showPreview="true" />
    </el-form-item>

    <el-form-item label="日常作业附件" prop="dailyAttachVos">
      <ml-upload
        multiple
        autoUpload
        :showFileList="false"
        :action="action"
        :data="{ linkType: 'error', type: 0 }"
        :headers="{ Authorization: toKen }"
        name="files"
        @on-success="onDailyUploadSuccess"
      >
        <el-button size="medium" icon="el-icon-circle-plus-outline" type="primary">
          上传附件
        </el-button>
      </ml-upload>
      <ml-list fileName="fileName" :list="submitReportForm.dailyAttachVos" :showPreview="true" />
    </el-form-item>
  </ml-form>
</template>
  <script>
import { useStore } from 'vuex'
import { computed, reactive, ref } from 'vue'
import { BASEURL, FILEUPLOADURL } from '@API'
export default {
  name: 'submitTaskDialog',
  props: {
    conf: {
      type: Object,
      default() {
        return {}
      }
    },
    btnCode: {
      type: String,
      default: ''
    },
    companyId: {
      type: String,
      default: ''
    },
    sourData: {
      type: Object,
      default() {
        return {}
      }
    },
    type: {
      type: String,
      default: 'edit'
    },
    inspectTaskId: {
      type: String,
      default: ''
    }
  },
  emits: ['success', 'close'],
  setup(props, context) {
    const { commit, getters } = useStore()
    const toKen = computed(() => getters.getToken)
    const formDisable = ref(props.type === 'view' ? true : false)
    const submitReportFormRef = ref()
    const isSafetyRemark = remark => typeof remark === 'string' && remark.startsWith('type_')
    const submitReportForm = reactive({
      startTime: props.type === 'view' ? props.sourData.startTime : '',
      endTime: props.type === 'view' ? props.sourData.endTime : '',
      content: props.type === 'view' ? props.sourData.content : '',
      safetyAttachVos:
        props.type === 'view'
          ? (props.sourData.attachVos || []).filter(item => isSafetyRemark(item.remark))
          : [],
      dailyAttachVos:
        props.type === 'view'
          ? (props.sourData.attachVos || []).filter(item => !isSafetyRemark(item.remark))
          : [],
      attachVos: [],
      inspectTaskId: props.inspectTaskId
    })
    // 校验
    const submitReportFormRule = {
      startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
      endTime: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
      content: [{ required: true, message: '请输入描述', trigger: 'blur' }],
      dailyAttachVos: [{ required: true, message: '请上传日常作业附件', trigger: 'change' }]
    }
    const disabledStartDate = value => {
      if (submitReportForm.endTime) {
        return value.getTime() > new Date(submitReportForm.endTime).getTime()
      }
      return false
    }

    const disabledEndDate = value => {
      if (submitReportForm.startTime) {
        return value.getTime() < new Date(submitReportForm.startTime).getTime()
      }
      return false
    }
    // 上传附件
    const action = ref(`${BASEURL}${FILEUPLOADURL}`)
    // 安全作业附件上传成功
    const onSafetyUploadSuccess = files => {
      if (files.data) {
        const items = files.data
        const compliantItems = items.filter(item => isSafetyRemark(item.remark))
        const hasNonCompliant = items.some(item => !isSafetyRemark(item.remark))
        if (hasNonCompliant) {
          commit('setError', {
            status: true,
            title: '',
            message: '上传的图片必须符合涉水、涉电、高空、道路作业中的一项要求',
            type: 'error'
          })
        }
        if (compliantItems.length > 0) {
          submitReportForm.safetyAttachVos = [
            ...submitReportForm.safetyAttachVos,
            ...compliantItems
          ]
        }
      }
    }
    // 日常作业附件上传成功
    const onDailyUploadSuccess = files => {
      if (files.data) {
        submitReportForm.dailyAttachVos = [...submitReportForm.dailyAttachVos, ...files.data]
      }
    }

    const dialogData = reactive({
      buttonCode: props.btnCode,
      procInsId: props.conf && props.conf.taskDto && props.conf.taskDto.processInstanceId,
      taskId: props.conf && props.conf.taskDto && props.conf.taskDto.id,
      variables: props.conf && props.conf.variables,
      comment: '',
      toUserId: '',
      customParamJson: '',
      fileList: [],
      nodeId: props.conf && props.conf.id,
      businessParamJson: '',
      created: props.conf && props.conf.taskDto && props.conf.taskDto.created,
      formConf: props.conf.formConf
    })

    const submitReportDialogSubmit = () => {
      return new Promise((resolve, reject) => {
        submitReportFormRef.value.CustomFormRef.validate().then(() => {
          submitReportForm.attachVos = [
            ...submitReportForm.safetyAttachVos,
            ...submitReportForm.dailyAttachVos
          ]
          dialogData.fileList = submitReportForm.attachVos
          dialogData.comment = submitReportForm.content
          dialogData.businessParamJson = JSON.stringify(submitReportForm)

          let startTime = new Date(submitReportForm.startTime).getTime()
          let endTime = new Date(submitReportForm.endTime).getTime()
          if (startTime > endTime) {
            commit('setError', {
              status: true,
              title: '',
              message: '结束时间不能小于开始时间',
              type: 'error'
            })
            reject()
            return
          }
          resolve({
            ...dialogData,
            startTime: submitReportForm.startTime,
            endTime: submitReportForm.endTime
          })
        })
      })
    }
    const closeHandle = () => {
      context.emit('close')
    }
    return {
      submitReportFormRef,
      submitReportForm,
      submitReportFormRule,
      disabledStartDate,
      disabledEndDate,
      submitReportDialogSubmit,
      onSafetyUploadSuccess,
      onDailyUploadSuccess,
      action,
      toKen,
      dialogData,
      closeHandle,
      formDisable
    }
  }
}
</script>